module.exports = __webpack_public_path__ + "img/email-action-sync-1.03f35b18.svg";